import { Stack, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

interface RoleTooltipEntry {
  label: string;
  description: string;
}

const getRoleTooltipEntries = (translation: Translation): RoleTooltipEntry[] => [
  {
    label: translation.administrator,
    description: translation.role_tooltip_administrator_description
  },
  {
    label: translation.installer,
    description: translation.role_tooltip_installer_description
  }
];

export const RoleColumnHeader: React.FC = () => {
  const { translation } = useTranslation();
  const entries = getRoleTooltipEntries(translation);

  return (
    <ColumnHeaderWithTooltip
      label={translation.role_or_roles}
      tooltip={
        <Stack spacing={1}>
          {entries.map((entry) => (
            <Stack key={entry.label}>
              <Typography variant="caption">
                <strong>{entry.label}:</strong>
              </Typography>
              <Typography variant="caption">{entry.description}</Typography>
            </Stack>
          ))}
        </Stack>
      }
    />
  );
};
